<div class="color-conflict-modal">
  <p class="conflict-message">
    Este color está asociado a los siguientes productos. Si guardas los cambios, el color se actualizará en todos ellos.
  </p>

  <ul class="product-list">
    @for (product of data.products; track product) {
      <li>{{ product }}</li>
    }
  </ul>

  <p class="conflict-confirm-text">¿Estás seguro de que quieres guardar los cambios de todas formas?</p>

  <div class="conflict-actions">
    <button type="button" class="btn btn-outline" (click)="onCancel()">Cancelar</button>
    <button type="button" class="btn btn-danger" (click)="onConfirm()">Sí, guardar igual</button>
  </div>
</div>
